import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/atoms/image/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/atoms/link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/checkout/payment-callback/CheckoutPaymentCallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMenu"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/footer/FooterMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/maintenance-bar/MaintenanceBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/market-button/MarketButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Module01"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/mod01HeroBanner/Module01.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Module07"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/mod07NewIn/Module07.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/not-found/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/product-details/helpers/adapter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/organisms/product-list/context/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreLocator"] */ "/opt/build/repo/packages/b2c/frontend/components/gruenland/pages/store-locator/StoreLocator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/yggdrasil/organisms/feedaty/AverageRatings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/yggdrasil/organisms/public-order/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/components/yggdrasil/organisms/returns/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/renderer/components/missing-tastic/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/gruenland/header/HeaderTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/gruenland/product-slider/ProductSliderTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/account-details/YggdrasilAccountDetailsTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/account-login/YggdrasilAccountLoginTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/account-register/YggdrasilAccountRegisterTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/account-reset-password/YggdrasilAccountResetPasswordTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/cart/YggdrasilCartTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/checkout/YggdrasilCheckoutTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/cta/YggdrasilCtaTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/hubspot-form/YggdrasilHubspotFormTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/image/YggdrasilImageTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/markdown/YggdrasilMarkdownTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/pdf/YggdrasilPdfTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/product-list/ProductListWrapped.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/related-products/YggdrasilRelatedProductsTastic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/frontastic/tastics/yggdrasil/thank-you/YggdrasilThankyouTastic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/packages/b2c/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/b2c/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/b2c/frontend/providers/index.tsx");
